export const extractNumericValue = (value) => {
  const symbolRegex = /[^\d.-]/g;
  if (typeof value === 'string') {
    const sanitizedValue = value.replace(symbolRegex, '');
    return parseFloat(sanitizedValue);
  }
  return Number(value);
};
